// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"bc4be7ef","787":"9824a286"}[chunkId] + ".chunk.js";
};